import {
    BG_COLOR_FULL_LIGHT,
    BG_COLOR_LIGHT,
    BG_COLOR_FULL_LIGHT_INVERTED,
    BG_COLOR_LIGHT_INVERTED,
} from './constants';
import type { TGetGradient } from './models';

/** Вычисление градиента через процесс прокрутки */
export const getGradient = ({ process, theme }: TGetGradient) => {
    const bgColor = theme === 'light' ? BG_COLOR_LIGHT_INVERTED : BG_COLOR_LIGHT;
    const bgFullColor = theme === 'light' ? BG_COLOR_FULL_LIGHT_INVERTED : BG_COLOR_FULL_LIGHT;

    return `linear-gradient(to right, ${bgFullColor} 0%, ${bgFullColor} ${process}%, ${bgColor} ${process}%, ${bgColor} 100%)`;
};
